import { useQuery } from "@tanstack/react-query";

import { useClient } from "@/providers/auth";

import { Device } from "@/features/system/types";

export const useStandbyDeviceQuery = (deviceId: string, enabled: boolean) => {
  const client = useClient();
  return useQuery<Device>({
    queryKey: ["standbyDevice", deviceId],
    queryFn: ({ signal }) =>
      client
        .get<Device>(`devices/standby/${deviceId}`, { signal })
        .then((response) => response.data),
    enabled: Boolean(deviceId) && enabled,
    retry: false,
  });
};
